import { Container } from "inversify";
import { TokenContainerModule } from "inversify-token";
import { YinzCamInjectModule } from "yinzcam-inject";
import { CardsLibraryRecord, CardsLibraryToken } from "../common/CardsLibraryToken";

import * as UnknownCard from "./UnknownCard/UnknownCard.svelte";
import * as PlaceholderCard from "./PlaceholderCard/PlaceholderCard.svelte";
import * as AdSlot from "./AdSlot/AdSlot.svelte";
import * as NavTop from "./NavTop/NavTop.svelte";
import * as FooterSponsor from "./FooterSponsor/FooterSponsor.svelte";
import * as FooterLinks from "./FooterLinks/FooterLinks.svelte";
import * as FooterSocial from "./FooterSocial/FooterSocial.svelte";
import * as FilterDropdown from "./FilterDropdown/FilterDropdown.svelte";
import * as FeatureMatchup from "./FeatureMatchup/FeatureMatchup.svelte";
import * as HTML from "./HTML/HTML.svelte";
import * as SectionHeading from "./SectionHeading/SectionHeading.svelte";
import * as SimpleCard from "./SimpleCard/SimpleCard.svelte";
import _ from "lodash";

//LimitedDrops
import * as LimitedDrops__ChatInput from './LimitedDrops/ChatInput/ChatInput.svelte';
import * as LimitedDrops__ChatLog from './LimitedDrops/ChatLog/ChatLog.svelte';
import * as LimitedDrops__Countdown from './LimitedDrops/Countdown/Countdown.svelte';
import * as LimitedDrops__EmailSignup from './LimitedDrops/EmailSignup/EmailSignup.svelte';
import * as LimitedDrops__HeaderCarouselCard from './LimitedDrops/HeaderCarouselCard/HeaderCarouselCard.svelte';
import * as LimitedDrops__Profile from './LimitedDrops/Profile/Profile.svelte';
import * as LimitedDrops__HeadshotAnim from './LimitedDrops/HeadshotAnim/HeadshotAnim.svelte';
import * as LimitedDrops__Address from './LimitedDrops/Address/Address.svelte';
import * as LimitedDrops__DropWinBottom from './LimitedDrops/DropWinBottom/DropWinBottom.svelte';
import * as LimitedDrops__PhoneSignup from './LimitedDrops/PhoneSignup/PhoneSignup.svelte';

const CARD_LIBRARY: { [ key: string ]: CardsLibraryRecord } = {
  UnknownCard,
  PlaceholderCard,
  AdSlot,
  NavTop,
  FooterSponsor,
  FooterLinks,
  FooterSocial,
  FilterDropdown,
  FeatureMatchup,
  HTML,
  SectionHeading,
  SimpleCard,
  LimitedDrops__ChatInput,
  LimitedDrops__ChatLog,
  LimitedDrops__Countdown,
  LimitedDrops__EmailSignup,
  LimitedDrops__HeaderCarouselCard,
  LimitedDrops__Profile,
  LimitedDrops__HeadshotAnim,
  LimitedDrops__Address,
  LimitedDrops__DropWinBottom,
  LimitedDrops__PhoneSignup
};

export const CardsLibraryModule: YinzCamInjectModule = new YinzCamInjectModule((container: Container): void => {
  container.load(new TokenContainerModule((bindToken) => {
    for (let k in CARD_LIBRARY) {
      const clazz = k.replace(/__/g, '.');
      const rec = CARD_LIBRARY[k];
      rec.clazz = clazz;
      let filtered = false;
      if (!_.isNil(CONFIG.cardClassFilters) && clazz !== 'PlaceholderCard' && clazz !== 'UnknownCard') {
        filtered = true;
        for (let filterKey in CONFIG.cardClassFilters) {
          const filter = CONFIG.cardClassFilters[filterKey];
          if ((filter.slice(-1) === '*' && clazz.startsWith(filter.slice(0, -2))) || clazz === filter) {
            filtered = false;
            break;
          }
        }
      }
      if (!filtered) {
        bindToken(CardsLibraryToken).toConstantValue(rec).whenTargetNamed(clazz);
      }
    }
  }));
});
